import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import { makeStyles } from "@mui/styles";
import React from "react";

function getModalStyle() {
  const top = 40;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: "auto",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    textAlign: "center",
  },
}));

export default (props) => {
  const classes = useStyles();
  const [modalStyle] = React.useState(getModalStyle);

  const open = props.open;
  const handleClose = props.handleClose;
  const name = props.name;
  const action = props.action;
  const uuid = props.uuid;
  const type = props.type;

  return (
    <Modal open={open} onClose={handleClose}>
      <div style={modalStyle} className={classes.paper}>
        <h2>Confirm Delete of Move In/Out</h2>
        <br />
        <p>Are you sure you want to delete the move in/out by: {name}</p>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => {
            action(uuid, type);
            handleClose();
          }}
        >
          Yes
        </Button>
      </div>
    </Modal>
  );
};
